// // Home.js
// import React from "react";
// import CategoryList from "../components/homepage/CategoryList";
// import HeroSlider from "../components/homepage/HeroSlider";
// import Adverts from "../components/homepage/Adverts";
// import usePageTitle from "../hooks/usePageTitle";
// import SponsoredProductsList from "../components/products/SponsoredProductsList";

// const Home = () => {
//   usePageTitle(`Agrolinka`);
//   return (
//     <div className="flex flex-col items-center">
//       {/* Hero Section */}
// <div className="w-full container mb-8 lg:flex lg:flex-row lg:space-x-4 lg:h-[400px]">
//         <div className="hidden lg:block lg:flex-1 h-full">
//           {/* Render CategoryList only on large screens */}
//           <CategoryList />
//         </div>
//         <div className="w-full lg:flex-[3] lg:h-full mb-4">
//           <HeroSlider />
//         </div>
//         <div className="w-full flex lg:flex-1 lg:h-full space-x-4">
//           {/* For mobile, stack Adverts side by side below the slider */}
//           <Adverts />
//         </div>
//       </div>

//       {/* Additional Sections */}
//       <SponsoredProductsList />
//       {/* Other sections here... */}
//     </div>
//   );
// };

// export default Home;

import React from "react";
import CategoryList from "../components/homepage/CategoryList";
import HeroSlider from "../components/homepage/HeroSlider";
import Adverts from "../components/homepage/Adverts";
import MobileHeroSlider from "../components/homepage/MobileHeroSlider";
import MobileAdverts from "../components/homepage/MobileAdverts";
import usePageTitle from "../hooks/usePageTitle";
import SponsoredProductsList from "../components/products/SponsoredProductsList";
import RentCube from "../components/homepage/RentCube";
import Settlements from "../components/homepage/Settlements";
import GreatDeals from "../components/homepage/GreatDeals";
import BusinessAtGlance from "../components/homepage/BusinessAtGlance";
import TestComp from "../components/homepage/TestComp";

const Home = () => {
  usePageTitle("Agrolinka");

  return (
    <div className="flex flex-col items-center">
      {/* Desktop View */}
      {/* <div className="hidden lg:flex space-x-4 w-full container"> */}
      <div className="hidden lg:flex w-full container mb-8 lg:flex lg:flex-row lg:space-x-4 lg:h-[400px]">
        <CategoryList />
        <HeroSlider />
        <Adverts />
      </div>

      {/* Mobile View */}
      <div className="lg:hidden flex flex-col items-center space-y-4  w-full ">
        <MobileHeroSlider />
        <MobileAdverts />
      </div>

      <SponsoredProductsList />

      <RentCube />
      {/* <TestComp /> */}
      <BusinessAtGlance />
      <Settlements />
      <GreatDeals />
      {/* Other sections of your homepage */}
    </div>
  );
};

export default Home;
